import { analyticsService, AnalyticsEventCatalog } from "../index";

/**
 * @param {"roster"|"spectator"|"tv"} inviteChannel
 */
export function trackInviteLinkCreated(inviteChannel) {
  analyticsService.track(AnalyticsEventCatalog.INVITE_LINK_CREATED, {
    invite_channel: inviteChannel,
  });
}

/**
 * @param {"roster"|"spectator"|"tv"} inviteChannel
 */
export function trackInviteQrGenerated(inviteChannel) {
  analyticsService.track(AnalyticsEventCatalog.INVITE_QR_GENERATED, {
    invite_channel: inviteChannel,
  });
}

/**
 * @param {{
 *   inviteChannel: "roster"|"spectator"|"tv";
 *   joinRole?: "owner"|"referee"|"deputy"|"player"|"spectator";
 * }} params
 */
export function trackInviteJoinCompleted(params) {
  const payload = {
    invite_channel: params.inviteChannel,
  };
  if (params.joinRole) {
    payload.join_role = params.joinRole;
  }
  analyticsService.track(AnalyticsEventCatalog.INVITE_JOIN_COMPLETED, payload);
}

/**
 * @param {string} url
 * @returns {"roster"|"spectator"}
 */
export function inviteChannelFromUrl(url) {
  if (!url || typeof url !== "string") return "spectator";
  try {
    const parsed = new URL(url, "https://local.invalid");
    const roster = (parsed.searchParams.get("roster") || "").toLowerCase();
    if (roster === "1" || roster === "true") return "roster";
  } catch {
    if (url.includes("roster=1")) return "roster";
  }
  return "spectator";
}
